<app-loading *ngIf="cargando"></app-loading>

<div [hidden]="cargando">
  <div class="modal-adjuntos">

    <!-- ===================== TOOLBAR ===================== -->
    <div class="toolbar-adjuntos" *ngIf="!detalle">
      <div class="toolbar-left">
        <p-checkbox
          binary="true"
          inputId="checkTodosModal"
          [(ngModel)]="checkTodos"
          (onChange)="toggleTodos($event)"
          class="espacio-alinear"
        ></p-checkbox>
        <label for="checkTodosModal" class="check-label espacio-alinear">{{ 'MATRIXADJUNTOSMODAL.LBL_SELECCIONARTODOS' | translate }}</label>
        <button
          pButton
          type="button"
          icon="fa fa-link"
          class="btn-primary-outline espacio-alinear"
          label="{{ 'MATRIXADJUNTOSMODAL.LBL_ENVIARRETOMA' | translate }}"
          [disabled]="!medioNotificacionSelected"
          (click)="enviarRetoma()"
        ></button>
        <div class="div-form">
          <label for="medio">* {{ 'MATRIXADJUNTOSMODAL.LBL_MEDIO' | translate}}</label>
          <p-dropdown
            [options]="listaMediosNotificaciones"
            [(ngModel)]="medioNotificacionSelected"
            placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            appendTo="body" id="medio"
            [style]="{'width': '200px'}"
          ></p-dropdown>
        </div>
      </div>
      <div class="toolbar-right">
        <button
          pButton
          type="button"
          icon="fa fa-plus"
          class="btn-primary-outline"
          label="{{ 'MATRIXADJUNTOSMODAL.LBL_AGREGAR' | translate }}"
          (click)="verPantallaAgregar = true"
          [disabled]="verPantallaAgregar"
        ></button>
      </div>
    </div>

    <!-- ===================== FORMULARIO AGREGAR (CON ANIMACIÓN) ===================== -->
    <div class="form-transition-container" [class.visible]="verPantallaAgregar">
      <form [formGroup]="formulario" class="agregar-panel">
        <div class="grid form-group">
          <!-- Dropdown Requisito -->
          <div class="col-5">
            <div class="div-form">
              <label>* {{ 'GESTIONADJUNTO.LBL_NOMBREADJUNTO' | translate }}</label>
              <p-dropdown
                id="adjuntosModal"
                name="adjuntosModal"
                [options]="listaRespaldosAdicionales"
                filter="filter"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                optionValue="value"
                formControlName="idRequisito"
                optionLabel="label"
                appendTo="body"
              ></p-dropdown>
              <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idRequisito.invalid">
                {{ 'GESTIONADJUNTO.LBL_NOMBREADJUNTO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
              </div>
            </div>
          </div>

          <!-- Input Descripción -->
          <div class="col-5">
            <div class="div-form">
              <label>{{ 'GESTIONADJUNTO.LBL_DESCRIPCION' | translate }}</label>
              <input type="text" pInputText formControlName="descripcion" id="descripcionModal" name="descripcionModal" [maxlength]="500" />
            </div>
          </div>

          <!-- Botones circulares Check / Times -->
          <div class="col-2 flex align-items-end gap-2 pb-2">
            <button
              pButton
              type="button"
              class="botones-circulares"
              icon="fa fa-check"
              (click)="guardarNuevoRequisito()"
            ></button>
            <button
              pButton
              type="button"
              class="botones-circulares"
              icon="fa fa-times"
              (click)="cancelarNuevoRequisito()"
            ></button>
          </div>
        </div>
      </form>
    </div>

    <!-- ===================== BUSCADOR ===================== -->
    <div class="buscador-container">
      <span class="p-input-icon-left w-full" style="width: 100% !important;">
        <i class="pi pi-search" style="font-size: 18px !important;"></i>
        <input
          type="text"
          pInputText
          id="buscadorAdjuntos"
          [(ngModel)]="textoBusqueda"
          (ngModelChange)="onBusqueda()"
          placeholder="{{ 'MATRIXADJUNTOSMODAL.LBL_BUSCAR' | translate }}"
          class="buscador-input"
        />
      </span>
    </div>

    <!-- ===================== LISTA DE ADJUNTOS ===================== -->
    <div class="lista-adjuntos">

      <!-- MÍNIMOS REQUERIDOS -->
      <ng-container *ngIf="listaMinimos.length > 0">
        <div class="seccion-header">
          <span>{{ 'MATRIXADJUNTOSMODAL.LBL_MINIMOS' | translate }}</span>
        </div>
        <ng-container *ngFor="let item of listaMinimos">
          <div class="fila-adjunto">
            <div class="fila-check">
              <p-checkbox
                binary="true"
                [(ngModel)]="item.indicadorRetoma"
                [disabled]="(!item.indicadorSolicitarCliente && !esPasarela) || item.idAdjunto"
                (onChange)="checkIndicadorTodos($event)"
              ></p-checkbox>
            </div>
            <div class="fila-info">
              <span class="fila-nombre">{{ item.nombreRespaldo }}</span>
              <span class="fila-descripcion" *ngIf="item.descripcionRespaldo">{{ item.descripcionRespaldo }}</span>
            </div>
            <div class="fila-acciones">
              <span [ngClass]="getEstadoBadgeClass(item)" class="estado-badge">
                {{ getEstadoLabel(item) }}
              </span>

              <div class="flex gap-2 align-items-center" style="height: 35px;">
                <!-- Si NO está cargado: p-fileUpload y clip -->
                <ng-container *ngIf="!item.idAdjunto">
                  <div class="file-false" style="height: inherit">
                    <p-fileUpload
                      name="file"
                      url="{{ item.indicadorTercero ? svcThUrlTercero : svcThUrl }}"
                      [auto]="false"
                      class="upload-avatar"
                      chooseLabel="{{ 'MATRIXADJUNTOSMODAL.LBL_ADJUNTAR' | translate }}"
                      (onBeforeUpload)="onBeforeSend($event)"
                      mode="basic"
                      (onValidSelect)="onSelect($event, $event.files)"
                      (onUpload)="onUpload($event, item)"
                      fSize
                      [codigoAdjunto]="item.codigo"
                      accept="{{ item.codigo === 'ESCDOC' ? 'application/pdf' : ftype }}"
                      [disabled]="!item.validacionPermisos || detalle"
                    ></p-fileUpload>
                    <button
                      type="button"
                      class="btn-action-premium"
                      pButton
                      icon="fa fa-paperclip"
                      [disabled]="!item.validacionPermisos || detalle"
                    ></button>
                  </div>
                </ng-container>

                <!-- Si SÍ está cargado: ojo (visualizar) y basura (eliminar) -->
                <ng-container *ngIf="item.idAdjunto">
                  <button
                    type="button"
                    class="btn-action-premium"
                    pButton
                    icon="fa fa-eye"
                    [disabled]="!item.idAdjunto"
                    (click)="verAdjunto(item)"
                  ></button>
                  <button
                    type="button"
                    class="btn-cancelar-premium"
                    pButton
                    *ngIf="!detalle"
                    icon="fa fa-trash"
                    [disabled]="!item.validacionPermisos"
                    (click)="eliminarAdjunto(item)"
                  ></button>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <!-- ADICIONALES -->
      <ng-container *ngIf="listaAdicionales.length > 0">
        <div class="seccion-header seccion-header--adicionales">
          <span>{{ 'MATRIXADJUNTOSMODAL.LBL_ADICIONALES' | translate }}</span>
        </div>
        <ng-container *ngFor="let item of listaAdicionales">
          <div class="fila-adjunto">
            <div class="fila-check">
              <p-checkbox
                binary="true"
                [(ngModel)]="item.indicadorRetoma"
                [disabled]="(!item.indicadorSolicitarCliente && !esPasarela) || item.idAdjunto"
                (onChange)="checkIndicadorTodos($event)"
              ></p-checkbox>
            </div>
            <div class="fila-info">
              <span class="fila-nombre">{{ item.nombreRespaldo }}</span>
              <span class="fila-descripcion" *ngIf="item.descripcionRespaldo">{{ item.descripcionRespaldo }}</span>
            </div>
            <div class="fila-acciones">
              <span [ngClass]="getEstadoBadgeClass(item)" class="estado-badge">
                {{ getEstadoLabel(item) }}
              </span>

              <div class="flex gap-2 align-items-center" style="height: 35px;">
                <!-- Si NO está cargado: p-fileUpload y clip -->
                <ng-container *ngIf="!item.idAdjunto">
                  <div class="file-false" style="height: inherit">
                    <p-fileUpload
                      name="file"
                      url="{{ item.indicadorTercero ? svcThUrlTercero : svcThUrl }}"
                      [auto]="false"
                      class="upload-avatar"
                      chooseLabel="{{ 'MATRIXADJUNTOSMODAL.LBL_ADJUNTAR' | translate }}"
                      (onBeforeUpload)="onBeforeSend($event)"
                      mode="basic"
                      (onValidSelect)="onSelect($event, $event.files)"
                      (onUpload)="onUpload($event, item)"
                      fSize
                      [codigoAdjunto]="item.codigo"
                      accept="{{ item.codigo === 'ESCDOC' ? 'application/pdf' : ftype }}"
                      [disabled]="!item.validacionPermisos"
                    ></p-fileUpload>
                    <button
                      type="button"
                      class="btn-action-premium"
                      pButton
                      icon="fa fa-paperclip"
                      [disabled]="!item.validacionPermisos"
                    ></button>
                  </div>
                </ng-container>

                <!-- Si SÍ está cargado: ojo (visualizar) y basura (eliminar) -->
                <ng-container>
                  <button
                    *ngIf="item.idAdjunto"
                    type="button"
                    class="btn-action-premium"
                    pButton
                    icon="fa fa-eye"
                    [disabled]="!item.idAdjunto"
                    (click)="verAdjunto(item)"
                  ></button>
                  <button
                    type="button"
                    class="btn-cancelar-premium"
                    pButton
                    *ngIf="!detalle"
                    icon="fa fa-trash"
                    [disabled]="!item.validacionPermisos"
                    (click)="eliminarAdjunto(item)"
                  ></button>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>

      <div *ngIf="listaMinimos.length === 0 && listaAdicionales.length === 0" class="text-center sin-registros">
        {{ 'MSG_NOHAYREGISTROS' | translate }}
      </div>
    </div>

    <!-- ===================== FOOTER ===================== -->
    <div class="modal-footer">
      <button type="button" pButton icon="fa fa-times"
              label="{{ 'MATRIXADJUNTOSMODAL.LBL_CERRAR' | translate }}"
              class="btn-primary-outline"
              (click)="cerrar()"></button>
    </div>
  </div>
</div>

<!-- Modal visualizar adjunto -->
<app-p-dialog-adjunto-custom
  *ngIf="showModalAdjunto"
  [showModalAdjunto]="showModalAdjunto"
  [loadingFile]="loadingFile"
  [fileUrl]="fileUrl"
  [subAdjunto]="false"
  [detalle]="!verRegistro.validacionPermisos || detalle"
  [svcThUrl]="verRegistro.indicadorTercero ? svcThUrlTercero : svcThUrl"
  [ftypemodal]="ftype"
  [autoGuardar]="false"
  (onBeforeSendEmit)="onBeforeSend($event)"
  (onSelectEmit)="onSelect($event, $event.files)"
  (onUploadEmit)="onUpload($event, verRegistro)"
  (cerrarModalAdjuntoEmit)="cerrarModalAdjunto()"
>
</app-p-dialog-adjunto-custom>

<!-- Modal visualizar adjunto pasarela -->
<app-matrix-visor-adjunto-pasarela
  *ngIf="esPasarela"
  [(visible)]="mostrarVisorPasarela"
  [adjunto]="adjuntoSeleccionadoPasarela"
  [idTerceroUPPasarela]="idTerceroUPPasarela"
  (onCalificado)="onAdjuntoCalificado($event)"
></app-matrix-visor-adjunto-pasarela>

<p-confirmDialog #cd key="inhabilitar-adjunto">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
